import { useState } from "react";
import { PublicPage, CONTACT_EMAIL } from "@/components/PublicChrome";
import { Mail, Send, Copy, Check } from "lucide-react";

export default function Contact() {
  const [copied, setCopied] = useState(false);
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const upd = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const copy = async () => {
    try { await navigator.clipboard.writeText(CONTACT_EMAIL); setCopied(true); setTimeout(() => setCopied(false), 1800); } catch {}
  };

  const mailto = () => {
    const subject = encodeURIComponent(`Orbit Online — message from ${form.name || "a pilot"}`);
    const body = encodeURIComponent(`${form.message}\n\n— ${form.name}${form.email ? ` (${form.email})` : ""}`);
    window.location.href = `mailto:${CONTACT_EMAIL}?subject=${subject}&body=${body}`;
  };

  return (
    <PublicPage title="Contact Us" subtitle="We'd love to hear from you">
      <p>Have a question, found a bug on the station, or want to share feedback? Reach the Orbit Online team directly by email, or use the quick message form below to open a pre-filled draft.</p>

      <div className="panel-glow p-5 flex items-center justify-between gap-4 not-prose">
        <div className="flex items-center gap-3 min-w-0">
          <span className="grid place-items-center w-10 h-10 rounded-[var(--radius)] bg-primary/15 text-primary shrink-0"><Mail className="w-5 h-5" /></span>
          <div className="min-w-0">
            <div className="label-cap">Email us</div>
            <a href={`mailto:${CONTACT_EMAIL}`} data-testid="contact-email" className="text-foreground font-semibold break-all hover:text-primary transition-colors">{CONTACT_EMAIL}</a>
          </div>
        </div>
        <button data-testid="copy-email-btn" onClick={copy} className="btn-ghost shrink-0">
          {copied ? <><Check className="w-4 h-4" /> Copied</> : <><Copy className="w-4 h-4" /> Copy</>}
        </button>
      </div>

      <form className="space-y-3 not-prose" onSubmit={(e) => { e.preventDefault(); mailto(); }}>
        <div className="grid sm:grid-cols-2 gap-3">
          <input data-testid="contact-name" required value={form.name} onChange={upd("name")} placeholder="Your callsign" className="input-field" />
          <input data-testid="contact-reply-email" type="email" value={form.email} onChange={upd("email")} placeholder="Your email (optional)" className="input-field" />
        </div>
        <textarea data-testid="contact-message" required value={form.message} onChange={upd("message")} rows={5} placeholder="Your message…" className="input-field resize-none" />
        <button type="submit" data-testid="contact-send-btn" className="btn-primary w-full py-3"><Send className="w-4 h-4" /> Compose email</button>
        <p className="text-xs text-muted-foreground text-center">This opens your email app with a pre-filled message — nothing is sent automatically.</p>
      </form>
    </PublicPage>
  );
}
